var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4H11.5C7.3585 4 4 7.3585 4 11.5V20.5C4 24.6415 7.3585 28 11.5 28H20.5C24.6415 28 28 24.6415 28 20.5V11.5C28 7.3585 24.6415 4 20.5 4ZM25.75 20.5C25.75 23.395 23.395 25.75 20.5 25.75H11.5C8.605 25.75 6.25 23.395 6.25 20.5V11.5C6.25 8.605 8.605 6.25 11.5 6.25H20.5C23.395 6.25 25.75 8.605 25.75 11.5V20.5Z",
    fill: "url(#paint0_linear_160_476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10C12.6865 10 10 12.6865 10 16C10 19.3135 12.6865 22 16 22C19.3135 22 22 19.3135 22 16C22 12.6865 19.3135 10 16 10ZM16 19.75C13.933 19.75 12.25 18.067 12.25 16C12.25 13.9315 13.933 12.25 16 12.25C18.067 12.25 19.75 13.9315 19.75 16C19.75 18.067 18.067 19.75 16 19.75Z",
    fill: "url(#paint1_linear_160_476)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_160_476_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000565275 -0.000565349 -0.00056535 -0.000565274 22.4504 9.55006)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3183.26,
    height: 3183.26,
    fill: "url(#paint2_diamond_160_476)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3183.26,
    height: 3183.26,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_160_476)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3183.26,
    height: 3183.26,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_160_476)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 3183.26,
    height: 3183.26,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_160_476)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.4504 10.3495C22.8919 10.3495 23.2499 9.99154 23.2499 9.54999C23.2499 9.10844 22.8919 8.75049 22.4504 8.75049C22.0088 8.75049 21.6509 9.10844 21.6509 9.54999C21.6509 9.99154 22.0088 10.3495 22.4504 10.3495Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.1305493116378784,\"m01\":-1.1306992769241333,\"m02\":22.450452804565430,\"m10\":-1.1306989192962646,\"m11\":-1.1305489540100098,\"m12\":10.680685997009277},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_160_476_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4504 10.3495C22.8919 10.3495 23.2499 9.99154 23.2499 9.54999C23.2499 9.10844 22.8919 8.75049 22.4504 8.75049C22.0088 8.75049 21.6509 9.10844 21.6509 9.54999C21.6509 9.99154 22.0088 10.3495 22.4504 10.3495Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_476",
    x1: 6.19697,
    y1: 25.8032,
    x2: 25.803,
    y2: 6.19682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_476",
    x1: 11.7575,
    y1: 20.2425,
    x2: 20.2425,
    y2: 11.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_160_476",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6125bd042b86b811d0a699cbba72bae7.svg";
export { ForwardRef as ReactComponent };